import axios from 'axios';
import * as url from './urlConfig'

///////////////////////////////// 登录页 ///////////////////////////////////
// 登录
export const requestLoginApi = params => { return axios.post(url.login, params).then(res => res.data); };

// 查询用户信息
export const getAdminUserByIdApi = params => { return axios.post(url.getAdminUserById, params).then(res => res.data); };

///////////////////////////////// 首页 ///////////////////////////////////



///////////////////////////////// 后台账户管理 ///////////////////////////////////

// 更新用户信息和密码
export const updateAdminUserPasswordApi = params => { return axios.post(url.updateAdminUserPassword, params).then(res => res.data); };

// 分页查询用户列表
export const getAdminUserByPageApi = params => { return axios.post(url.getAdminUserByPage, params).then(res => res.data); };

// 新增后台用户
export const addNewAdminUserApi = params => { return axios.post(url.addNewAdminUser, params).then(res => res.data); };

// 更新后台用户
export const updateAdminUserByIdApi = params => { return axios.post(url.updateAdminUserById, params).then(res => res.data); };

// 重置后台用户密码
export const resetPasswordByAdminUserIdApi = params => { return axios.post(url.resetPasswordByAdminUserId, params).then(res => res.data); };

// 删除后台用户
export const deleteAdminUserByIdApi = params => { return axios.post(url.deleteAdminUserById, params).then(res => res.data); };

///////////////////////////////// 用户数据管理 ///////////////////////////////////

// 分页查询用户列表
export const getUserByPage = params => { return axios.post(url.getUserByPage, params).then(res => res.data); };

// 新增用户
export const addNewUser = params => { return axios.post(url.addNewUser, params).then(res => res.data); };

// 更新用户
export const updateUserById = params => { return axios.post(url.updateUserById, params).then(res => res.data); };

// 删除用户
export const deleteUserById = params => { return axios.post(url.deleteUserById, params).then(res => res.data); };

// 重置用户密码
export const resetUserPassword = params => { return axios.post(url.resetUserPassword, params).then(res => res.data); };

///////////////////////////////////  字典管理  /////////////////////////////////////

// 根据id查询字典
export const querySysDictByIdApi = params => { return axios.post(url.querySysDictById, params).then(res => res.data); };

// 根据code查询字典
export const getSysDictByCodeApi = params => { return axios.post(url.getSysDictByCode, params).then(res => res.data); };

// 更新字典
export const updateSysDictByIdApi = params => { return axios.post(url.updateSysDictById, params).then(res => res.data); };

///////////////////////////////// 基础数据管理 ///////////////////////////////////

// 分页查询传感器
export const querySensorByPageApi = params => { return axios.post(url.querySensorByPage, params).then(res => res.data); };

// 查询所有传感器
export const querySensorAllApi = params => { return axios.post(url.querySensorAll, params).then(res => res.data); };

// 查询传感器详情
export const querySensorByIdApi = params => { return axios.post(url.querySensorById, params).then(res => res.data); };

// 新增传感器
export const saveSensorApi = params => { return axios.post(url.saveSensor, params).then(res => res.data); };

// 更新传感器
export const updateSensorByIdApi = params => { return axios.post(url.updateSensorById, params).then(res => res.data); };

// 删除传感器
export const deleteSensorByIdApi = params => { return axios.post(url.deleteSensorById, params).then(res => res.data); };

// 根据传感器id查询传感器状态
export const querySensorDetailBySensorIdApi = params => { return axios.post(url.querySensorDetailBySensorId, params).then(res => res.data); };

//////////////////////////////////////////////////  任务  /////////////////////////////////////////////////////

// 分页查询任务
export const queryTaskByPageApi = params => { return axios.post(url.queryTaskByPage, params).then(res => res.data); };

// 查询任务详情
export const queryTaskByIdApi = params => { return axios.post(url.queryTaskById, params).then(res => res.data); };

// 新增任务
export const saveTaskApi = params => { return axios.post(url.saveTask, params).then(res => res.data); };

// 更新任务
export const updateTaskByIdApi = params => { return axios.post(url.updateTaskById, params).then(res => res.data); };

// 删除任务
export const deleteTaskByIdApi = params => { return axios.post(url.deleteTaskById, params).then(res => res.data); };

//////////////////////////////////////////////////  子任务  /////////////////////////////////////////////////////

// 分页查询子任务
export const queryTaskSubByPageApi = params => { return axios.post(url.queryTaskSubByPage, params).then(res => res.data); };

// 查询子任务详情
export const queryTaskSubByIdApi = params => { return axios.post(url.queryTaskSubById, params).then(res => res.data); };

// 新增子任务
export const saveTaskSubApi = params => { return axios.post(url.saveTaskSub, params).then(res => res.data); };

// 更新子任务
export const updateTaskSubByIdApi = params => { return axios.post(url.updateTaskSubById, params).then(res => res.data); };

// 删除子任务
export const deleteTaskSubByIdApi = params => { return axios.post(url.deleteTaskSubById, params).then(res => res.data); };

// 分页查询定时任务队列
export const queryScheduleTaskByPageApi = params => { return axios.post(url.queryScheduleTaskByPage, params).then(res => res.data); };

// 分页查询定时任务队列
export const updateScheduleTaskByIdApi = params => { return axios.post(url.updateScheduleTaskById, params).then(res => res.data); };

//////////////////////////////////////////////////  图片采集  /////////////////////////////////////////////////////

// 分页查询采集的图片列表
export const queryPicCollectByPageApi = params => { return axios.post(url.queryPicCollectByPage, params).then(res => res.data); };

// 根据id批量删除数据（逻辑删除）
export const batchDeletePicCollByIdsApi = params => { return axios.post(url.batchDeletePicCollByIds, params).then(res => res.data); };

// 特殊导入图片
export const specialImportPicApi = params => { return axios.post(url.specialImportPic, params).then(res => res.data); };

// 更新图片信息
export const updatePicByIdApi = params => { return axios.post(url.updatePicById, params).then(res => res.data); };

// 导出子任务下的全景图像、损伤图片、参数结果
export const exportPanoramaAnalysisParametersApi = params => { return axios.post(url.exportPanoramaAnalysisParameters, params).then(res => res.data); };

// 图片转换
export const convertPicApi = params => { return axios.post(url.convertPic, params).then(res => res.data); };

// 测线合并
export const mixPicApi = params => { return axios.post(url.mixPic, params).then(res => res.data); };

// 根据id查询图片详情
export const queryPicCollectByIdApi = params => { return axios.post(url.queryPicCollectById, params).then(res => res.data); };

//////////////////////////////////////////////////  操作传感器  /////////////////////////////////////////////////////

// 查询传感器在线状态
export const querySensorOnlineStatusApi = params => { return axios.post(url.querySensorOnlineStatus, params).then(res => res.data); };

// 初始化传感器状态
export const initSensorStatusApi = params => { return axios.post(url.initSensorStatus, params).then(res => res.data); };

// 查询传感器距离、角度、陀螺仪各状态
export const querySensorStatusApi = params => { return axios.post(url.querySensorStatus, params).then(res => res.data); };

// 控制传感器（马达、灯光、测距仪）
export const operateSensorApi = params => { return axios.post(url.operateSensor, params).then(res => res.data); };

// 单次采集图片
export const collectPicApi = params => { return axios.post(url.collectPic, params).then(res => res.data); };

// 自动采集图像
export const autoCollectPicApi = params => { return axios.post(url.autoCollectPic, params).then(res => res.data); };

// 查询传感器测距与陀螺仪状态
export const querySensorDistanceAndGyroApi = params => { return axios.post(url.querySensorDistanceAndGyro, params).then(res => res.data); };

// 开启传感器摄像服务
export const openCameraApi = params => { return axios.post(url.openCamera, params).then(res => res.data); };

// 关闭传感器摄像服务
export const stopCameraApi = params => { return axios.post(url.stopCamera, params).then(res => res.data); };

//////////////////////////////////////////////////  损伤分析  /////////////////////////////////////////////////////

// 获取图像分析默认参数
export const getDefaultAnalysisParamsApi = params => { return axios.post(url.getDefaultAnalysisParams, params).then(res => res.data); };

// 异步批量分析图像
export const asyncBatchAnalysisPicApi = params => { return axios.post(url.asyncBatchAnalysisPic, params).then(res => res.data); };

// 异步批量分析图像
export const asyncBatchAnalysisPicNewApi = params => { return axios.post(url.asyncBatchAnalysisPicNew, params).then(res => res.data); };

// 分页查询损伤分析结果列表
export const queryPicAnalysisByPageApi = params => { return axios.post(url.queryPicAnalysisByPage, params).then(res => res.data); };

// 删除损伤分析结果
export const deletePicAnalysisApi = params => { return axios.post(url.deletePicAnalysis, params).then(res => res.data); };

// 查询损伤分析来源图
export const getPicAnalysisSourceApi = params => { return axios.post(url.getPicAnalysisSource, params).then(res => res.data); };

// 分页查询图片分析项
export const queryPicAnalysisItemByPageApi = params => { return axios.post(url.queryPicAnalysisItemByPage, params).then(res => res.data); };

// 录入二值化图
export const recordBinaryImageApi = params => { return axios.post(url.recordBinaryImage, params).then(res => res.data); };

// 根据二值化图计算损伤参数
export const calcMarByBinaryImageApi = params => { return axios.post(url.calcMarByBinaryImage, params).then(res => res.data); };

// 批量下载分析项图片
export const downloadPicAnalysisItemsApi = params => { return axios.post(url.downloadPicAnalysisItems, params).then(res => res.data); };

// 自动二值化分析
export const autoCreateBinaryImageApi = params => { return axios.post(url.autoCreateBinaryImage, params).then(res => res.data); };

// 自动计算参数
export const autoCalcParamsApi = params => { return axios.post(url.autoCalcParams, params).then(res => res.data); };

// 更新损伤分析结果
export const updatePicAnalysisApi = params => { return axios.post(url.updatePicAnalysis, params).then(res => res.data); };

// 根据id查询分析详情
export const queryPicAnalysisByIdApi = params => { return axios.post(url.queryPicAnalysisById, params).then(res => res.data); };

// 正式图像分析
export const analysisPicByFormalApi = params => { return axios.post(url.analysisPicByFormal, params).then(res => res.data); };

// 切图图像分析
export const analysisPicByCutApi = params => { return axios.post(url.analysisPicByCut, params).then(res => res.data); };

// 保存分析结果
export const analysisPicBySaveApi = params => { return axios.post(url.analysisPicBySave, params).then(res => res.data); };

//////////////////////////////////////////////////  三维重建  /////////////////////////////////////////////////////

// 新增三维重建任务
export const savePicRebuildApi = params => { return axios.post(url.savePicRebuild, params).then(res => res.data); };

// 更新三维重建任务
export const updatePicRebuildApi = params => { return axios.post(url.updatePicRebuild, params).then(res => res.data); };

// 设置三维重建结果
export const setRebuildResultApi = params => { return axios.post(url.setRebuildResult, params).then(res => res.data); };

// 分页查询三维重建
export const queryPicRebuildByPageApi = params => { return axios.post(url.queryPicRebuildByPage, params).then(res => res.data); };

// 删除三维重建结果
export const deletePicRebuildApi = params => { return axios.post(url.deletePicRebuild, params).then(res => res.data); };

// 三维重建
export const rebuildPicApi = params => { return axios.post(url.rebuildPic, params).then(res => res.data); };

// 三维重建（视频）
export const rebuildByVideoApi = params => { return axios.post(url.rebuildByVideo, params).then(res => res.data); };

// 分页查询三维重建源
export const queryPicRebuildSourceByPageApi = params => { return axios.post(url.queryPicRebuildSourceByPage, params).then(res => res.data); };

//////////////////////////////////////////////////  模型设置  /////////////////////////////////////////////////////

// 处理文件夹下的所有图片 - 异步批量
export const imageHandleByFolderApi = params => { return axios.post(url.imageHandleByFolder, params).then(res => res.data); };

// 打开本地指定的文件夹
export const openWinLocalFolderApi = params => { return axios.post(url.openWinLocalFolder, params).then(res => res.data); };

//////////////////////////////////////////////////  全景图像、摄像机标定  /////////////////////////////////////////////////////

// 生成全景图像
export const generatePanoramaViewApi = params => { return axios.post(url.generatePanoramaView, params).then(res => res.data); };

// 摄像机标定
export const generateCameraSetImageApi = params => { return axios.post(url.generateCameraSetImage, params).then(res => res.data); };

//////////////////////////////////////////////////  通用任务  /////////////////////////////////////////////////////

// 分页查询通用任务
export const queryCommonTaskByPageApi = params => { return axios.post(url.queryCommonTaskByPage, params).then(res => res.data); };

// 查询通用任务详情
export const queryCommonTaskByIdApi = params => { return axios.post(url.queryCommonTaskById, params).then(res => res.data); };

// 新增通用任务
export const saveCommonTaskApi = params => { return axios.post(url.saveCommonTask, params).then(res => res.data); };

// 修改通用任务
export const updateCommonTaskByIdApi = params => { return axios.post(url.updateCommonTaskById, params).then(res => res.data); };

// 删除通用任务
export const deleteCommonTaskByIdApi = params => { return axios.post(url.deleteCommonTaskById, params).then(res => res.data); };

//////////////////////////////////////////////////  通用资源  /////////////////////////////////////////////////////

// 分页查询通用资源
export const queryResourceByPageApi = params => { return axios.post(url.queryResourceByPage, params).then(res => res.data); };

// 查询通用资源详情
export const queryResourceByIdApi = params => { return axios.post(url.queryResourceById, params).then(res => res.data); };

// 新增通用资源
export const saveResourceApi = params => { return axios.post(url.saveResource, params).then(res => res.data); };

// 修改通用资源
export const updateResourceByIdApi = params => { return axios.post(url.updateResourceById, params).then(res => res.data); };

// 删除通用资源
export const deleteResourceByIdApi = params => { return axios.post(url.deleteResourceById, params).then(res => res.data); };

//////////////////////////////////////////////////  分析模型及网络训练  /////////////////////////////////////////////////////

// 分页查询分析模型
export const queryAnalysisModelByPageApi = params => { return axios.post(url.queryAnalysisModelByPage, params).then(res => res.data); };

// 查询分析模型详情
export const queryAnalysisModelByIdApi = params => { return axios.post(url.queryAnalysisModelById, params).then(res => res.data); };

// 新增分析模型
export const saveAnalysisModelApi = params => { return axios.post(url.saveAnalysisModel, params).then(res => res.data); };

// 修改分析模型
export const updateAnalysisModelByIdApi = params => { return axios.post(url.updateAnalysisModelById, params).then(res => res.data); };

// 删除分析模型
export const deleteAnalysisModelByIdApi = params => { return axios.post(url.deleteAnalysisModelById, params).then(res => res.data); };

// 查询可用模型
export const getAvailableModelsApi = params => { return axios.post(url.getAvailableModels, params).then(res => res.data); };

// 预训练
export const preNetTrainApi = params => { return axios.post(url.preNetTrain, params).then(res => res.data); };

// 开始训练
export const startTrainApi = params => { return axios.post(url.startTrain, params).then(res => res.data); };

// 查询训练日志、损失函数、平均精度（训练中）
export const queryNetTrainByScheduleTaskApi = params => { return axios.post(url.queryNetTrainByScheduleTask, params).then(res => res.data); };

// 查询训练日志、损失函数、平均精度（训练结束）
export const queryTrainLogApi = params => { return axios.post(url.queryTrainLog, params).then(res => res.data); };

//////////////////////////////////////////////////  视频录像  /////////////////////////////////////////////////////

// 查询传感器是否有正在录制的进程
export const getProcessKeyBySensorIdApi = params => { return axios.post(url.getProcessKeyBySensorId, params).then(res => res.data); };

// 开始录像
export const videoBeginRecordApi = params => { return axios.post(url.videoBeginRecord, params).then(res => res.data); };

// 结束录像
export const videoEndRecordApi = params => { return axios.post(url.videoEndRecord, params).then(res => res.data); };

// 强制结束录像
export const forceVideoEndRecordApi = params => { return axios.post(url.forceVideoEndRecord, params).then(res => res.data); };

//////////////////////////////////////////////////  订单相关  /////////////////////////////////////////////////////

// 分页查询订单
export const queryOrderByPageApi = params => { return axios.post(url.queryOrderByPage, params).then(res => res.data); };

// 查询订单详情
export const queryOrderByIdApi = params => { return axios.post(url.queryOrderById, params).then(res => res.data); };

// 订单退款
export const refundOrderByIdApi = params => { return axios.post(url.refundOrderById, params).then(res => res.data); };

// 下载图片
export const downloadOrderPicApi = params => { return axios.post(url.downloadOrderPic, params).then(res => res.data); };

// 刷新订单
export const refreshOrderByIdApi = params => { return axios.post(url.refreshOrderById, params).then(res => res.data); };

// 设置退款申请状态
export const setRefundApplyStatusApi = params => { return axios.post(url.setRefundApplyStatus, params).then(res => res.data); };

// 设置流程状态
export const setProcessStatusApi = params => { return axios.post(url.setProcessStatus, params).then(res => res.data); };

// 发送订单短信
export const sendOrderSmsApi = params => { return axios.post(url.sendOrderSms, params).then(res => res.data); };

// 导出订单Excel
export const exportOrderExcelApi = params => { return axios.post(url.exportOrderExcel, params).then(res => res.data); };

//////////////////////////////////////////////////  上大屏配置相关  /////////////////////////////////////////////////////

// 分页查询上大屏文字
export const queryHandTextByPageApi = params => { return axios.post(url.queryHandTextByPage, params).then(res => res.data); };

// 新增编辑上大屏文字
export const addOrUpdateHandTextApi = params => { return axios.post(url.addOrUpdateHandText, params).then(res => res.data); };

// 切换上大屏文字状态
export const updateHandTextStatusApi = params => { return axios.post(url.updateHandTextStatus, params).then(res => res.data); };

// 分页查询上大屏时间
export const queryHandTimeByPageApi = params => { return axios.post(url.queryHandTimeByPage, params).then(res => res.data); };

// 新增编辑上大屏时间
export const addOrUpdateHandTimeApi = params => { return axios.post(url.addOrUpdateHandTime, params).then(res => res.data); };

// 切换上大屏时间状态
export const updateHandTimeStatusApi = params => { return axios.post(url.updateHandTimeStatus, params).then(res => res.data); };

// 批量更改时间状态
export const batchUpdateStatusApi = params => { return axios.post(url.batchUpdateStatus, params).then(res => res.data); };

// 分页查询上大屏日期
export const queryHandDateByPageApi = params => { return axios.post(url.queryHandDateByPage, params).then(res => res.data); };

// 新增编辑上大屏日期
export const addOrUpdateHandDateApi = params => { return axios.post(url.addOrUpdateHandDate, params).then(res => res.data); };

// 切换上大屏日期状态
export const updateHandDateStatusApi = params => { return axios.post(url.updateHandDateStatus, params).then(res => res.data); };

// 批量更改日期状态
export const batchUpdateDateStatusApi = params => { return axios.post(url.batchUpdateDateStatus, params).then(res => res.data); };

// 查询上大屏配置
export const queryHandDictDetailApi = params => { return axios.post(url.queryHandDictDetail, params).then(res => res.data); };

// 保存上大屏配置
export const saveHandDictDetailApi = params => { return axios.post(url.saveHandDictDetail, params).then(res => res.data); };























///////////////////////////////// 测试使用 ///////////////////////////////////

export const getUserList = params => { return axios.get(url.userList, { params: params }); };

export const getUserListPage = params => { return axios.get(url.userListpage, { params: params }); };

export const removeUser = params => { return axios.get(url.userRemove, { params: params }); };

export const batchRemoveUser = params => { return axios.get(url.userBatchremove, { params: params }); };

export const editUser = params => { return axios.get(url.userEdit, { params: params }); };

export const addUser = params => { return axios.get(url.userAdd, { params: params }); };


//category
export const getCategoryList = params => { return axios.get(url.categoryList, { params: params }); };

export const getCategoryListPage = params => { return axios.get(url.categoryListpage, { params: params }); };

export const removeCategory = params => { return axios.get(url.categoryRemove, { params: params }); };

export const batchRemoveCategory = params => { return axios.get(url.categoryBatchremove, { params: params }); };

export const editCategory = params => { return axios.get(url.categoryEdit, { params: params }); };

export const addCategory = params => { return axios.get(url.categoryAdd, { params: params }); };

//maintain
export const getMaintainList = params => { return axios.get(url.maintainList, { params: params }); };

export const getMaintainListPage = params => { return axios.get(url.maintainListpage, { params: params }); };

export const removeMaintain = params => { return axios.get(url.maintainRemove, { params: params }); };

export const batchRemoveMaintain = params => { return axios.get(url.maintainBatchremove, { params: params }); };

export const editMaintain = params => { return axios.get(url.maintainEdit, { params: params }); };

export const addMaintain = params => { return axios.get(url.maintainAdd, { params: params }); };

//plan
export const getPlanList = params => { return axios.get(url.planList, { params: params }); };

export const getPlanListPage = params => { return axios.get(url.planListpage, { params: params }); };

export const removePlan = params => { return axios.get(url.planRemove, { params: params }); };

export const batchRemovePlan = params => { return axios.get(url.planBatchremove, { params: params }); };

export const editPlan = params => { return axios.get(url.planEdit, { params: params }); };

export const addPlan = params => { return axios.get(url.planAdd, { params: params }); };


// WEBPACK FOOTER //
// ./src/api/api.js